import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import ProjectView from "./ProjectView";
import ProjectEdit from "./ProjectEdit";
import {clearProject, getProject, setProjectDrop} from "../../actions/projects";
import { setContractDrop } from "../../actions/contract";
import { setInvoiceDrop } from "../../actions/invoices";

export function ProjectSingle(props) {

const project = useSelector(state => state.projects.project);
const projectDrop = useSelector(state => state.projects.projectDrop);
const contractDrop = useSelector(state => state.contract.contractDrop);
const invoiceDrop = useSelector(state => state.invoices.invoiceDrop);

const projectId = props.match.params.id;

const [render, setRender] = useState(projectId === project.project_id);


// on mount or when a different project is selected, get project data
useEffect(() => {
    if (projectId === "new") {
        project.project_id && props.clearProject();
    } else {
        projectId !== project.project_id && props.getProject(projectId);
    }
}, [props.match.params.id])


// when the correct project data returns
    // make sure drop selections are correct
    // then render the component
useEffect(() => {
    if ((!project.project_id && projectId === "new") || project.project_id === projectId) {
        // if drops are wrong, reset them
        if (project.project_id) {
            (projectDrop.project_id !== project.project_id) && props.setProjectDrop({project_id: project.project_id, project_name: project.project_name});
            (contractDrop.project_id && contractDrop.project_id !== project.project_id) && props.setContractDrop({});
            (invoiceDrop.project_id && invoiceDrop.project_id !== project.project_id) && props.setInvoiceDrop({});
        } else {
            projectDrop.project_id && props.setProjectDrop({});
            contractDrop.project_id && props.setContractDrop({});
            invoiceDrop.project_id && props.setInvoiceDrop({});
        }
        !render && setRender(true)
    }
}, [project.project_id])


const handleReroute = (path) => {
    props.history.push(path)
}


    return (
        <>
            {render &&
            <>
                {props.match.params.mode === "view"
                ?<ProjectView handleReroute={handleReroute} match={props.match} />
                :<ProjectEdit handleReroute={handleReroute} match={props.match} />
                }
            </>
            }
        </>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {
    clearProject, 
    getProject, 
    setProjectDrop,
    setContractDrop,
    setInvoiceDrop,
})(ProjectSingle);